import { Controller } from "@hotwired/stimulus"

const DAYS_BEFORE_SELECTED = 2

export default class extends Controller {
  static targets = ["strip", "selected", "previous", "next"]

  connect() {
    if (this.hasSelectedTarget) this.reveal(this.selectedTarget, "auto")

    this.syncArrows()
    this.ready = true
  }

  disconnect() {
    this.ready = false
  }

  // A morph keeps the strip's scroll position, so a selection made from the popup has to bring itself into view.
  selectedTargetConnected(day) {
    if (this.ready && !this.inView(day)) this.reveal(day, this.scrollBehavior)
  }

  scrollPrevious() {
    this.stripTarget.scrollBy({ left: -this.stripTarget.clientWidth, behavior: this.scrollBehavior })
  }

  scrollNext() {
    this.stripTarget.scrollBy({ left: this.stripTarget.clientWidth, behavior: this.scrollBehavior })
  }

  syncArrows() {
    const { scrollLeft, clientWidth, scrollWidth } = this.stripTarget

    this.previousTarget.disabled = scrollLeft <= 0
    this.nextTarget.disabled = scrollLeft + clientWidth >= scrollWidth - 1
  }

  reveal(day, behavior) {
    this.stripTarget.scrollTo({ left: day.offsetLeft - DAYS_BEFORE_SELECTED * day.offsetWidth, behavior })
  }

  inView({ offsetLeft, offsetWidth }) {
    const { scrollLeft, clientWidth } = this.stripTarget

    return offsetLeft >= scrollLeft && offsetLeft + offsetWidth <= scrollLeft + clientWidth
  }

  get scrollBehavior() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
  }
}
